/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, count: NonNullable<unknown> }} Your_Sovereign_Tier_Includes_OInputs */

const en_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.tier} tier includes ${i?.count} free standard domain registration (.com, .store, .net) mapped instantly to your storefront.`)
};

const es_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu nivel Sovereign incluye el registro gratuito de un dominio estándar (.com, .store, .net) vinculado instantáneamente a tu tienda.`)
};

const fr_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre niveau Sovereign comprend l'enregistrement gratuit d'un domaine standard (.com, .store, .net) mappé instantanément à votre vitrine.`)
};

const de_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Sovereign-Stufe beinhaltet eine kostenlose Standard-Domainregistrierung (.com, .store, .net), die sofort mit deiner Storefront verknüpft wird.`)
};

const ja_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sovereignティアには、1つの標準ドメイン登録 (.com, .store, .net) が無料で含まれており、即座にストアフロントにマッピングされます。`)
};

const zh_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的 Sovereign 级别包含一个免费的标准域名注册 (.com, .store, .net)，并即刻映射至您的店铺。`)
};

const ar_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يتضمن مستوى Sovereign الخاص بك تسجيلاً مجانياً واحداً لنطاق قياسي (.com, .store, .net) يتم ربطه فوراً بواجهة متجرك.`)
};

const id_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paket Sovereign Anda mencakup satu pendaftaran domain standar gratis (.com, .store, .net) yang dipetakan langsung ke etalase Anda.`)
};

const it_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo livello Sovereign include la registrazione gratuita di un dominio standard (.com, .store, .net) mappato istantaneamente alla tua vetrina.`)
};

const ru_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш тариф Sovereign включает одну бесплатную регистрацию стандартного домена (.com, .store, .net), мгновенно привязанного к вашей витрине.`)
};

const pt_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu plano Sovereign inclui um registro de domínio padrão gratuito (.com, .store, .net) mapeado instantaneamente para sua vitrine.`)
};

const ko_your_sovereign_tier_includes_o = /** @type {(inputs: Your_Sovereign_Tier_Includes_OInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`귀하의 Sovereign 등급에는 스토어프론트에 즉시 매핑되는 표준 도메인(.com, .store, .net) 1개 무료 등록이 포함됩니다.`)
};

/**
* | output |
* | --- |
* | "Your {tier} tier includes {count} free standard domain registration (.com, .store, .net) mapped instantly to your storefront." |
*
* @param {Your_Sovereign_Tier_Includes_OInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_sovereign_tier_includes_o = /** @type {((inputs: Your_Sovereign_Tier_Includes_OInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Sovereign_Tier_Includes_OInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_sovereign_tier_includes_o(inputs)
	if (locale === "es") return es_your_sovereign_tier_includes_o(inputs)
	if (locale === "fr") return fr_your_sovereign_tier_includes_o(inputs)
	if (locale === "de") return de_your_sovereign_tier_includes_o(inputs)
	if (locale === "ja") return ja_your_sovereign_tier_includes_o(inputs)
	if (locale === "zh") return zh_your_sovereign_tier_includes_o(inputs)
	if (locale === "ar") return ar_your_sovereign_tier_includes_o(inputs)
	if (locale === "id") return id_your_sovereign_tier_includes_o(inputs)
	if (locale === "it") return it_your_sovereign_tier_includes_o(inputs)
	if (locale === "ru") return ru_your_sovereign_tier_includes_o(inputs)
	if (locale === "pt") return pt_your_sovereign_tier_includes_o(inputs)
	return ko_your_sovereign_tier_includes_o(inputs)
});